import { multipleSelect } from 'multiple-select-vanilla';

class SalesforceForm {
    constructor(el) {
        if (!this.set(el)) return;

        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' &&
                !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.formEl = this.root.querySelector('form');
        this.selectEl = this.root.querySelectorAll('.salesforce-form__select');

        return true;
    }

    init() {
        this.setSubmit();
        this.setSelects();
    }

    async setSubmit() {
        this.onSubmit = this.onFormSubmit.bind(this);
        this.formEl.addEventListener('submit', this.onSubmit);
    }

    setSelects() {
        if (!this.selectEl) return;

        this.selectEl.forEach(node => {
            let selectEl = node.querySelector(
                '.salesforce-form__select-handler'
            );
            let inputEl = node.querySelector('.salesforce-form__select-input');
            let instance = multipleSelect(selectEl, {
                single: true,
            });

            selectEl.addEventListener('change', event => {
                const { currentTarget } = event;
                const { value } = currentTarget;

                if (inputEl) {
                    inputEl.value = value;
                }
            });
        });
    }

    async onFormSubmit(event) {
        /*event.preventDefault();
        const formData = new FormData(this.formEl);
        const url = this.formEl.getAttribute('action');
        const urlEncoded = new URLSearchParams(formData);

        const request = await fetch(`${url}`, {
            method: 'POST',
            body: urlEncoded,
            mode: 'no-cors',
        });

        const res = await request.json();
        console.log(res);*/
    }
}

const initSalesforceForm = () => {
    const sections = document.querySelectorAll('[data-salesforce-form]');
    if (sections) sections.forEach(item => new SalesforceForm(item));
};

initSalesforceForm();
